module.exports = __webpack_public_path__ + "static/media/pos icon 1.d9dd04e0.png";